import { type TokenClaims } from '@/models/domain/auth'

const TOKEN_KEY = 'auth_token'
const TOKEN_EXPIRY_KEY = 'auth_token_expiry'

export function saveToken(token: string, expiresIn: number): void {
  const expiryTime = Date.now() + expiresIn * 1000
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(TOKEN_EXPIRY_KEY, expiryTime.toString())
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(TOKEN_EXPIRY_KEY)
}

function getTokenExpiry(): number | null {
  const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY)
  return expiry ? parseInt(expiry, 10) : null
}

export function isTokenExpired(): boolean {
  const expiry = getTokenExpiry()
  if (!expiry) return true
  return Date.now() >= expiry
}

function getTimeUntilExpiry(): number {
  const expiry = getTokenExpiry()
  if (!expiry) return 0
  return Math.max(0, expiry - Date.now())
}

export function isTokenExpiringSoon(warningThresholdMs: number = 10 * 60 * 1000): boolean {
  const timeUntilExpiry = getTimeUntilExpiry()
  return timeUntilExpiry > 0 && timeUntilExpiry <= warningThresholdMs
}

export function decodeToken(token: string): TokenClaims | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null

    const payload = parts[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded) as TokenClaims
  } catch {
    return null
  }
}
